import { useTranslation } from 'react-i18next';
import { Card } from '../../shared/Card/Card';
import { CardHeaderSkeleton } from '../../shared/CardHeader/CardHeaderSkeleton';
import { Shimmer } from '../../shared/Shimmer/Shimmer';
import styles from './ExpectedVsActualSkeleton.module.css';

/** Fixed, varied heights so the placeholder reads as a chart rather than a wall
 *  of equal blocks. Each pair is one bucket's earned/actual bars. */
const BAR_HEIGHTS: [number, number][] = [
  [86, 70], [78, 66], [72, 64], [70, 65], [84, 78], [62, 56], [70, 64],
];

/** Loading state for {@link ExpectedVsActual} — paired bars per bucket, plus footer. */
export function ExpectedVsActualSkeleton() {
  const { t } = useTranslation();
  return (
    <Card aria-busy="true" aria-label={t('productivity.skeleton.loading')}>
      <CardHeaderSkeleton size="sm" />
      <div className={styles.chart}>
        {BAR_HEIGHTS.map(([earned, actual], i) => (
          <div key={i} className={styles.bucket}>
            <div className={styles.bars}>
              <Shimmer className={styles.bar} wave={i * 0.05} style={{ height: `${earned}%` }} />
              <Shimmer className={styles.bar} wave={i * 0.05} style={{ height: `${actual}%` }} />
            </div>
            <Shimmer className={styles.tickLabel} wave={i * 0.05} />
            <Shimmer className={styles.tickPct} wave={i * 0.05} />
          </div>
        ))}
      </div>
      <div className={styles.footer}>
        <Shimmer className={styles.legend} />
        <Shimmer className={styles.periodAvg} />
      </div>
    </Card>
  );
}